<template>
  <div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20"
      >
        <md-field>
          <label for="contractorRegion"> Filter by Contractor: </label
          ><md-select
            v-model="filterCriteria.contractorRegionId"
            name="contractorRegion"
            id="contractorRegion"
            @md-selected="onFilterChange"
          >
            <md-option value="0">All</md-option>
            <md-option
              v-for="contractorRegion in permittedContractorRegions"
              :key="contractorRegion.id"
              :value="contractorRegion.id"
            >
              {{ contractorRegion.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card header-color="warning">
          <template slot="header">
            <div class="card-icon">
              <md-icon>{{ quoteIcon }}</md-icon>
            </div>
            <p class="category">Quotes to approve</p>
            <h3 class="title">
              <router-link
                class="linkcolour"
                :to="{
                  name: 'Live Quotes',
                  query: {
                    clientId: this.filterCriteria.clientId,
                    contractorRegionId: this.filterCriteria.contractorRegionId,
                    statusId: 2
                  }
                }"
                ><strong>{{ quoteMetric.count }}</strong></router-link
              >
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              Last quote approval:
              {{ quoteMetric.lastUpdatedDate }}
            </div>
          </template>
        </stats-card>
      </div>
    </div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
      >
        <chart-card
          header-animation="false"
          :chart-data="plantWithoutStatInspChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>Plant Total:</strong>
              {{ this.plantWithoutStatInspChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i
                ><span>
                  <router-link
                    class="add-spacing"
                    :to="{
                      name: 'Plants without Stat. Insp.',
                      query: {
                        contractorRegionId: filterCriteria.contractorRegionId
                      }
                    }"
                    >Plant without Stat. Insp.<strong
                      >({{ plantWithoutStatInspChart.data.series[0] }})</strong
                    ></router-link
                  > </span
                >&nbsp;&nbsp;<i class="fa fa-circle text-success"></i>
                <span>
                  <router-link
                    class="add-spacing"
                    :to="{
                      name: 'List Statutory Inspections',
                      query: {
                        contractorRegionId: filterCriteria.contractorRegionId
                      }
                    }"
                    >Plant with Stat. Insp.<strong
                      >({{ plantWithoutStatInspChart.data.series[1] }})</strong
                    ></router-link
                  > </span
                >&nbsp;&nbsp;
              </div>
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
      >
        <chart-card
          header-animation="false"
          :chart-data="statInspStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>Stat. Insp. Status</strong>
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i
                ><span>
                  <router-link
                    class="add-spacing"
                    :to="{
                      name: 'List Statutory Inspections',
                      query: {
                        statInspStatusId: 3,
                        contractorRegionId: filterCriteria.contractorRegionId
                      }
                    }"
                    >Overdue<strong
                      >({{ statInspStatusesChart.data.series[0] }})</strong
                    ></router-link
                  > </span
                >&nbsp;&nbsp; <i class="fa fa-circle text-warning"></i
                ><span>
                  <router-link
                    class="add-spacing"
                    :to="{
                      name: 'List Statutory Inspections',
                      query: {
                        statInspStatusId: 2,
                        contractorRegionId: filterCriteria.contractorRegionId
                      }
                    }"
                    >Expired<strong
                      >({{ statInspStatusesChart.data.series[2] }})</strong
                    ></router-link
                  > </span
                >&nbsp;&nbsp; <i class="fa fa-circle text-success"></i>
                <span>
                  <router-link
                    class="add-spacing"
                    :to="{
                      name: 'List Statutory Inspections',
                      query: {
                        statInspStatusId: 1,
                        contractorRegionId: filterCriteria.contractorRegionId
                      }
                    }"
                    >Active<strong
                      >({{ statInspStatusesChart.data.series[1] }})</strong
                    ></router-link
                  >
                </span>
              </div>
            </div>
          </template>
        </chart-card>
      </div>
    </div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          header-animation="false"
          :chart-data="timedDefectStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>Timed Defect Status</strong> - Total:
              {{ this.timedDefectStatusesChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i>
                <chart-link
                  :typeId="1"
                  :statusId="1"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="timedDefectStatusesChart.data.series[0]"
                />
                <i class="fa fa-circle text-quote"></i>
                <chart-link
                  :typeId="1"
                  :statusId="7"
                  :clientId="filterCriteria.clientId"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="timedDefectStatusesChart.data.series[3]"
                />
                <i class="fa fa-circle text-warning"></i>
                <chart-link
                  :typeId="1"
                  :statusId="2"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="timedDefectStatusesChart.data.series[2]"
                />
                <i class="fa fa-circle text-gray"></i>
                <chart-link
                  :typeId="1"
                  :statusId="4"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="timedDefectStatusesChart.data.series[4]"
                />
                <i class="fa fa-circle text-info"></i>
                <chart-link
                  :typeId="1"
                  :statusId="5"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="timedDefectStatusesChart.data.series[5]"
                />
                <i class="fa fa-circle text-purple"></i
                ><chart-link
                  :typeId="1"
                  :statusId="6"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="timedDefectStatusesChart.data.series[6]"
                />
              </div>
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          header-animation="false"
          :chart-data="untimedDefectStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>Untimed Defect Status</strong> - Total:
              {{ this.untimedDefectStatusesChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i>
                <chart-link
                  :typeId="2"
                  :statusId="1"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="untimedDefectStatusesChart.data.series[0]"
                />
                <i class="fa fa-circle text-quote"></i>
                <chart-link
                  :typeId="2"
                  :statusId="7"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="untimedDefectStatusesChart.data.series[3]"
                />
                <i class="fa fa-circle text-warning"></i>
                <chart-link
                  :typeId="2"
                  :statusId="2"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="untimedDefectStatusesChart.data.series[2]"
                />
                <i class="fa fa-circle text-gray"></i>
                <chart-link
                  :typeId="2"
                  :statusId="4"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="untimedDefectStatusesChart.data.series[4]"
                />
                <i class="fa fa-circle text-info"></i>
                <chart-link
                  :typeId="2"
                  :statusId="5"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="untimedDefectStatusesChart.data.series[5]"
                />
                <i class="fa fa-circle text-purple"></i
                ><chart-link
                  :typeId="2"
                  :statusId="6"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="untimedDefectStatusesChart.data.series[6]"
                />
              </div>
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          header-animation="false"
          :chart-data="safedStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>SAFed Status</strong> - Total:
              {{ this.safedStatusesChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i>
                <chart-link
                  :typeId="5"
                  :statusId="1"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="safedStatusesChart.data.series[0]"
                />
                <i class="fa fa-circle text-quote"></i>
                <chart-link
                  :typeId="5"
                  :statusId="7"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="safedStatusesChart.data.series[3]"
                />
                <i class="fa fa-circle text-warning"></i>
                <chart-link
                  :typeId="5"
                  :statusId="2"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="safedStatusesChart.data.series[2]"
                />
                <i class="fa fa-circle text-gray"></i>
                <chart-link
                  :typeId="5"
                  :statusId="4"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="safedStatusesChart.data.series[4]"
                />
                <i class="fa fa-circle text-info"></i>
                <chart-link
                  :typeId="5"
                  :statusId="5"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="safedStatusesChart.data.series[5]"
                />
                <i class="fa fa-circle text-purple"></i
                ><chart-link
                  :typeId="5"
                  :statusId="6"
                  :contractorRegionId="filterCriteria.contractorRegionId"
                  :value="safedStatusesChart.data.series[6]"
                />
              </div>
            </div>
          </template>
        </chart-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ChartCard, StatsCard } from "@/components";
import ChartLink from "./components/ChartLink";
export default {
  components: {
    ChartCard,
    ChartLink,
    StatsCard
  },
  async created() {
    await this.getChartdData();
  },
  computed: {
    ...mapGetters({
      plantWithoutStatInspChart: "report/plantWithoutStatInspChartData",
      timedDefectStatusesChart: "report/timedDefectStatusesChartData",
      untimedDefectStatusesChart: "report/untimedDefectStatusesChartData",
      safedStatusesChart: "report/safedStatusesChartData",
      statInspStatusesChart: "report/statInspStatusesChartData",
      quoteMetric: "report/quoteMetric",
      quoteIcon: "quote/icon"
    }),
    permittedContractorRegions() {
      return this.$auth.profile.contractorRegions;
    }
  },
  data() {
    return {
      options: {
        donut: true,
        donutWidth: 35,
        showLabel: false
      },
      filterCriteria: {
        contractorRegionId: "0"
      }
    };
  },
  methods: {
    async getChartdData() {
      await this.$store.dispatch("report/getDashboard", {
        contractorRegionId: this.filterCriteria.contractorRegionId
      });
    },
    async onFilterChange() {
      await this.getChartdData();
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.category {
  margin: 0;
}

.md-card-actions .md-layout-item {
  padding: 0;
}
.linkcolour strong {
  color: #3c4858 !important;
}
</style>
